(() => {
  'use strict';

  const CARD_SELECTOR = '[data-camo-card-v2]';

  const handleize = (value) => String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');


  const normalizeFilterValue = (value) => {
    const normalized = handleize(value);
    if (normalized === 'box') return 'boxes';
    if (normalized === 'pouch' || normalized === 'patch' || normalized === 'patches') return 'pouches';
    return normalized;
  };

  const getActiveCollectionOptionFilters = (card = null) => {
    const active = { type: '', packType: '' };
    const params = new URLSearchParams(window.location.search);

    params.forEach((rawValue, rawKey) => {
      const prefix = 'filter.v.option.';
      if (!String(rawKey).toLowerCase().startsWith(prefix)) return;

      const optionName = handleize(String(rawKey).slice(prefix.length));
      const value = normalizeFilterValue(rawValue);
      if (!value) return;

      if (optionName === 'type') active.type = value;
      if (optionName === 'pack-type' || optionName === 'pack') active.packType = value;
    });

    const productPageType = normalizeFilterValue(params.get('filter_type'));
    const productPagePackType = normalizeFilterValue(params.get('filter_pack_type'));

    if (productPageType === 'wraps' || productPageType === 'cones') active.type = productPageType;
    if (productPagePackType === 'boxes' || productPagePackType === 'pouches') active.packType = productPagePackType;

    const contextRoot = card?.closest?.('[data-camo-card-context]');
    if (contextRoot && card) {
      card.dataset.camoSectionContextType = contextRoot.dataset.camoContextType || 'both';
      card.dataset.camoSectionContextPackType = contextRoot.dataset.camoContextPackType || 'both';
    }

    const sectionType = normalizeFilterValue(
      contextRoot?.dataset.camoContextType || card?.dataset.camoSectionContextType
    );
    const sectionPackType = normalizeFilterValue(
      contextRoot?.dataset.camoContextPackType || card?.dataset.camoSectionContextPackType
    );

    if (sectionType && sectionType !== 'both') active.type = sectionType;
    if (sectionPackType && sectionPackType !== 'both') active.packType = sectionPackType;

    if (window.location.pathname.replace(/\/+$/, '') === '/search') {
      const terms = String(params.get('q') || '')
        .toLowerCase()
        .match(/[a-z0-9]+/g) || [];
      const termSet = new Set(terms);
      const hasWraps = termSet.has('wrap') || termSet.has('wraps');
      const hasCones = termSet.has('cone') || termSet.has('cones');
      const hasBoxes = termSet.has('box') || termSet.has('boxes');
      const hasPouches = termSet.has('pouch') || termSet.has('pouches');

      if (!active.type && hasWraps !== hasCones) active.type = hasWraps ? 'wraps' : 'cones';
      if (!active.packType && hasBoxes !== hasPouches) active.packType = hasBoxes ? 'boxes' : 'pouches';
    }

    return active;
  };

  const getFilteredSelectionDetail = (optionName, value, active, card) => {
    if (optionName === 'type') {
      if (value === 'wraps') return '4¼ × 1¾″';
      if (value === 'cones') return 'King Size';
    }

    if (optionName === 'pack-type' || optionName === 'pack') {
      const selectedTypeButton = card.querySelector('[data-option-name="Type"] [data-card-option-value].is-selected');
      const selectedType = active.type || normalizeFilterValue(
        selectedTypeButton?.dataset.cardOptionHandle || selectedTypeButton?.dataset.cardOptionValue
      );
      const isCones = selectedType === 'cones';

      if (value === 'boxes') return isCones ? '12 pouches each' : '25 pouches each';
      if (value === 'pouches') return isCones ? '4 cones each' : '5 wraps each';
    }

    return '';
  };

  const syncFilteredSelectionHeading = (card, group, optionName, requiredValue, active) => {
    const key = optionName === 'type' ? 'type' : 'pack-type';
    let heading = card.querySelector(`[data-camo-filter-selection-heading="${key}"]`);

    if (!requiredValue) {
      heading?.remove();
      return;
    }

    const selectedButton = [...group.querySelectorAll('[data-card-option-value]')].find((button) => {
      return normalizeFilterValue(button.dataset.cardOptionHandle || button.dataset.cardOptionValue) === requiredValue;
    });
    if (!selectedButton) {
      heading?.remove();
      return;
    }

    if (!heading) {
      heading = document.createElement('div');
      heading.className = 'xo-product-card-v2__filter-selection-heading';
      heading.dataset.camoFilterSelectionHeading = key;
      group.parentNode?.insertBefore(heading, group);
    }

    const title = selectedButton.querySelector('.xo-product-card-v2__option-title')?.textContent?.trim()
      || selectedButton.dataset.cardOptionValue
      || requiredValue;
    const detail = getFilteredSelectionDetail(optionName, requiredValue, active, card)
      || selectedButton.querySelector('.xo-product-card-v2__option-detail')?.textContent?.trim()
      || '';

    heading.replaceChildren();

    const titleNode = document.createElement('span');
    titleNode.className = 'xo-product-card-v2__filter-selection-title';
    titleNode.textContent = title;
    heading.appendChild(titleNode);

    if (detail) {
      const detailNode = document.createElement('span');
      detailNode.className = 'xo-product-card-v2__filter-selection-detail';
      detailNode.textContent = detail;
      heading.appendChild(detailNode);
    }
  };

  const applyCollectionFilterVisibility = (card) => {
    if (!(card instanceof Element)) return;
    const active = getActiveCollectionOptionFilters(card);

    card.querySelectorAll('[data-option-name]').forEach((group) => {
      const optionName = handleize(group.dataset.optionName);
      let requiredValue = '';

      if (optionName === 'type') requiredValue = active.type;
      if (optionName === 'pack-type' || optionName === 'pack') requiredValue = active.packType;

      group.toggleAttribute('data-camo-filter-active', Boolean(requiredValue));
      syncFilteredSelectionHeading(card, group, optionName, requiredValue, active);

      group.querySelectorAll('[data-card-option-value]').forEach((button) => {
        const buttonValue = normalizeFilterValue(button.dataset.cardOptionHandle || button.dataset.cardOptionValue);
        const shouldHide = Boolean(requiredValue);
        button.toggleAttribute('hidden', shouldHide);
        button.toggleAttribute('data-camo-filter-hidden', shouldHide);
        button.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      });
    });
  };

  const syncCollectionFilterVisibility = (root = document) => {
    const cards = [];
    if (root instanceof Element && root.matches(CARD_SELECTOR)) cards.push(root);
    if (root?.querySelectorAll) cards.push(...root.querySelectorAll(CARD_SELECTOR));
    cards.forEach(applyCollectionFilterVisibility);
  };

  const parseJson = (el, fallback) => {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent || ''); } catch (e) { return fallback; }
  };

  const money = (value, currency = 'USD') => {
    const number = Number(value);
    if (!Number.isFinite(number)) return '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(number);
    } catch (e) {
      return `$${number.toFixed(2)}`;
    }
  };

  const fireCartEvents = (detail) => {
    ['cart:refresh', 'cart:open', 'cart:updated', 'cart:change', 'ajaxProduct:added', 'product:added', 'xo:cart:refresh', 'xo:cart:open', 'xo:cart:add', 'xo:cart:change'].forEach((name) => {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
      window.dispatchEvent(new CustomEvent(name, { detail }));
    });
  };

  const replaceNodeContents = (selector, sourceDoc) => {
    let replaced = false;
    document.querySelectorAll(selector).forEach((node) => {
      const uid = node.getAttribute('xo-unique-id');
      const fresh = sourceDoc.querySelector(uid ? `${selector}[xo-unique-id="${uid}"]` : selector);
      if (!fresh) return;
      node.innerHTML = fresh.innerHTML;
      replaced = true;
    });
    return replaced;
  };

  const refreshCartDrawer = async (detail) => {
    fireCartEvents(detail);
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('_camo_multi_flavor_refresh', Date.now().toString());
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (response.ok) {
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        replaceNodeContents('xo-cart-will-change', doc);
        replaceNodeContents('xo-cart-size', doc);
        replaceNodeContents('[data-cart-count]', doc);
        replaceNodeContents('[data-header-cart-count]', doc);
      }
    } catch (error) {
      console.warn('Camo multi-flavor cart refresh failed', error);
    }
    requestAnimationFrame(() => {
      const trigger = document.querySelector('xo-modal-trigger[xo-name="cart-drawer"], xo-modal-trigger[xo-name="cart"], xo-modal-trigger[xo-name*="cart"], [data-cart-drawer-trigger], [data-cart-trigger], .header__cart, .cart-icon, a[href="/cart"]');
      if (trigger && typeof trigger.click === 'function') trigger.click();
      setTimeout(() => fireCartEvents(detail), 200);
    });
  };

  const normalizeGroups = (data) => {
    if (!data) return [];
    if (Array.isArray(data.groups)) return data.groups;
    if (Array.isArray(data.products)) return data.products;
    if (Array.isArray(data)) return data;
    return [];
  };

  const sortedBreakpoints = (group) => {
    return (Array.isArray(group?.breakpoints) ? group.breakpoints : [])
      .map((bp) => ({
        ...bp,
        quantity: Number(bp.quantity),
        discount_percentage: Number(bp.discount_percentage ?? bp.discountPercentage ?? bp.discount ?? 0)
      }))
      .filter((bp) => Number.isFinite(bp.quantity) && bp.quantity > 0 && bp.discount_percentage > 0)
      .sort((a, b) => a.quantity - b.quantity);
  };

  class CamoProductCardV2 {
    constructor(card) {
      this.card = card;
      this.variants = parseJson(card.querySelector('[data-card-variants-json]'), []);
      this.forcedPack = card.dataset.forcedPack || '';
      this.forcedPackType = card.dataset.forcedPackType || '';
      this.pricing = parseJson(card.querySelector('[data-card-pricing-json]'), null);
      this.groups = normalizeGroups(this.pricing);
      this.options = this.getInitialOptions();
      this.applyActiveFilterSelection();
      this.form = card.querySelector('.xo-product-card-v2__form');
      this.variantInput = card.querySelector('[data-card-variant-input]');
      this.qtyInput = card.querySelector('.xo-product-card-v2__quantity-input');
      this.cartAdd = card.querySelector('xo-cart-add');
      this.dynamicCheckout = card.querySelector('.xo-product-card-v2__dynamic-checkout');
      this.totalEl = card.querySelector('[data-card-total-price]');
      this.perPouchEl = card.querySelector('[data-card-per-pouch]');
      this.milestonesWrap = card.querySelector('[data-card-milestone-nodes]');
      this.milestones = card.querySelector('[data-card-milestones]');
      this.addButton = card.querySelector('[data-card-add-button]');
      this.selectionSummaries = [...card.querySelectorAll('[data-card-selection-summary]')];
      this.lastMilestoneKey = '';
      this.flavorIndex = Number(card.dataset.flavorOptionIndex);
      this.flavorWraps = [...card.querySelectorAll('[data-camo-flavor-qty-wrap]')];
      this.flavorImages = parseJson(card.querySelector('[data-camo-flavor-variant-images]'), []);
      this.flavorQuantities = new Map();
      this.lastTouchedFlavor = '';
      this.flavorClickStamp = { flavor: '', time: 0 };
      this.installCartAddOptionsBridge();
      this.installQuickshopSummaryPlacement();
      this.installDeferredDynamicCheckout();
      applyCollectionFilterVisibility(this.card);
      this.bind();
      this.installFlavorIntegration();
      this.update();
      this.ensureCardFlavorCarouselView();
    }


    installDeferredDynamicCheckout() {
      if (!this.dynamicCheckout) return;
      const template = this.dynamicCheckout.querySelector('[data-card-payment-button-template]');
      if (!template) return;

      const hydrate = () => {
        if (this.dynamicCheckout.dataset.camoCheckoutHydrated === 'true') return;
        this.dynamicCheckout.dataset.camoCheckoutHydrated = 'true';
        this.dynamicCheckout.appendChild(template.content.cloneNode(true));
        template.remove();
        this.checkoutHydrationObserver?.disconnect();
      };

      if ('IntersectionObserver' in window) {
        this.checkoutHydrationObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) hydrate();
        }, { rootMargin: '300px 0px' });
        this.checkoutHydrationObserver.observe(this.card);
      } else {
        hydrate();
      }

      this.card.addEventListener('pointerenter', hydrate, { once: true, passive: true });
      this.card.addEventListener('focusin', hydrate, { once: true });
      this.card.addEventListener('touchstart', hydrate, { once: true, passive: true });
    }


    ensureCardFlavorCarouselView() {
      if (this.card.dataset.hasFlavorVariants !== 'true') return;

      const galleryRoot = this.card.querySelector('[data-camo-card-flavor-carousel] .xo-product-info-variant--camo-flavor');
      const gallery = galleryRoot?.querySelector('.xo-product-info-variant__inner--camo-flavor');
      const logicalWraps = [...(gallery?.querySelectorAll('[data-camo-flavor-gallery-item]') || [])];
      if (!galleryRoot || !gallery || !logicalWraps.length || gallery.dataset.camoCardCarouselReady === 'true') return;

      gallery.dataset.camoCardCarouselReady = 'true';
      gallery.dataset.camoFlavorGalleryReady = 'true';
      gallery.dataset.camoFlavorView = 'carousel';
      gallery.classList.add('camo-flavor-gallery');
      gallery.setAttribute('tabindex', gallery.getAttribute('tabindex') || '0');
      galleryRoot.classList.remove('is-camo-flavor-grid-view');
      galleryRoot.classList.add('is-camo-flavor-carousel-view');

      let galleryFrame = 0;
      let galleryScrolling = false;
      let loopJumping = false;
      let previousScrollLeft = gallery.scrollLeft;

      const existingToggle = galleryRoot.querySelector('[data-camo-flavor-view-toggle]');
      if (existingToggle) existingToggle.remove();

      let pagination = galleryRoot.querySelector('.camo-flavor-gallery__pagination');
      if (pagination) pagination.remove();
      pagination = document.createElement('div');
      pagination.className = 'camo-flavor-gallery__pagination';
      pagination.setAttribute('role', 'tablist');
      pagination.setAttribute('aria-label', 'Flavor gallery');

      const setGalleryItemState = (activeWrap, selectFlavor = false) => {
        if (!activeWrap) return;
        logicalWraps.forEach((item, index) => {
          const isActive = item === activeWrap;
          item.classList.toggle('is-camo-flavor-gallery-active', isActive);
          item.setAttribute('aria-current', isActive ? 'true' : 'false');
          const dot = pagination.children[index];
          dot?.classList.toggle('is-active', isActive);
          dot?.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive && dot) {
            const accent = getComputedStyle(item).getPropertyValue('--camo-flavor-accent-resolved').trim();
            if (accent) dot.style.setProperty('--camo-dot-accent', accent);
          }
        });

        if (selectFlavor) {
          const flavor = activeWrap.dataset.camoFlavor || '';
          if (flavor) {
            this.selectFlavor(flavor);
            this.update();
          }
        }
      };

      logicalWraps.forEach((wrap, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'camo-flavor-gallery__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', wrap.dataset.camoFlavor || `Flavor ${index + 1}`);
        dot.setAttribute('aria-selected', 'false');
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          setGalleryItemState(wrap, true);
          scrollGalleryItemToCenter(wrap, 'smooth');
        });
        pagination.appendChild(dot);
      });
      galleryRoot.appendChild(pagination);

      const activeItem = () => logicalWraps.find((item) => item.classList.contains('is-camo-flavor-gallery-active'))
        || logicalWraps.find((item) => item.querySelector('input[type="radio"]:checked'))
        || logicalWraps[0];

      const restoreLogicalOrder = () => logicalWraps.forEach((item) => gallery.appendChild(item));

      const scrollGalleryItemToCenter = (item, behavior = 'smooth') => {
        if (!item) return;
        const left = item.offsetLeft - ((gallery.clientWidth - item.offsetWidth) / 2);
        gallery.scrollTo({ left: Math.max(0, left), behavior });
      };

      const centerCarouselItem = (item, behavior = 'auto') => {
        if (!item) return;
        restoreLogicalOrder();
        if (logicalWraps.length > 2) {
          const activeIndex = logicalWraps.indexOf(item);
          const desiredIndex = Math.floor(logicalWraps.length / 2);
          const split = (activeIndex - desiredIndex + logicalWraps.length) % logicalWraps.length;
          logicalWraps.slice(split).concat(logicalWraps.slice(0, split)).forEach((entry) => gallery.appendChild(entry));
        }
        scrollGalleryItemToCenter(item, behavior);
        previousScrollLeft = gallery.scrollLeft;
      };

      const itemStep = () => {
        const items = [...gallery.querySelectorAll('[data-camo-flavor-gallery-item]')];
        if (items.length < 2) return items[0]?.getBoundingClientRect().width || 0;
        return Math.abs(items[1].offsetLeft - items[0].offsetLeft) || items[0].getBoundingClientRect().width;
      };

      const jumpWithoutAnimation = (callback) => {
        loopJumping = true;
        gallery.classList.add('is-camo-loop-jumping');
        callback();
        gallery.getBoundingClientRect();
        requestAnimationFrame(() => {
          gallery.classList.remove('is-camo-loop-jumping');
          loopJumping = false;
        });
      };

      const rebalanceInfiniteLoop = () => {
        if (logicalWraps.length < 3 || loopJumping) return;
        const step = itemStep();
        if (!step) return;
        const max = gallery.scrollWidth - gallery.clientWidth;
        const movingRight = gallery.scrollLeft >= previousScrollLeft;

        if (movingRight && gallery.scrollLeft > max - step * 1.35) {
          const first = gallery.querySelector('[data-camo-flavor-gallery-item]');
          if (first) jumpWithoutAnimation(() => {
            gallery.appendChild(first);
            gallery.scrollLeft -= step;
          });
        } else if (!movingRight && gallery.scrollLeft < step * 1.35) {
          const items = gallery.querySelectorAll('[data-camo-flavor-gallery-item]');
          const last = items[items.length - 1];
          if (last) jumpWithoutAnimation(() => {
            gallery.insertBefore(last, items[0]);
            gallery.scrollLeft += step;
          });
        }
        previousScrollLeft = gallery.scrollLeft;
      };

      const closestToGalleryCenter = () => {
        const galleryRect = gallery.getBoundingClientRect();
        const center = galleryRect.left + galleryRect.width / 2;
        return logicalWraps.reduce((closest, item) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs((rect.left + rect.width / 2) - center);
          return !closest || distance < closest.distance ? { item, distance } : closest;
        }, null)?.item;
      };

      const updateGalleryFromScroll = () => {
        galleryFrame = 0;
        rebalanceInfiniteLoop();
        setGalleryItemState(closestToGalleryCenter(), galleryScrolling && !loopJumping);
      };

      const queueGalleryUpdate = () => {
        if (loopJumping) return;
        galleryScrolling = true;
        if (!galleryFrame) galleryFrame = requestAnimationFrame(updateGalleryFromScroll);
        window.clearTimeout(gallery._camoFlavorScrollEnd);
        gallery._camoFlavorScrollEnd = window.setTimeout(() => {
          galleryScrolling = false;
          rebalanceInfiniteLoop();
          const activeWrap = closestToGalleryCenter();
          setGalleryItemState(activeWrap, true);
          scrollGalleryItemToCenter(activeWrap, 'smooth');
        }, 180);
      };

      gallery.addEventListener('scroll', queueGalleryUpdate, { passive: true });
      gallery.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const domWraps = [...gallery.querySelectorAll('[data-camo-flavor-gallery-item]')];
        const activeIndex = Math.max(0, domWraps.findIndex((item) => item.classList.contains('is-camo-flavor-gallery-active')));
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (activeIndex + direction + domWraps.length) % domWraps.length;
        event.preventDefault();
        scrollGalleryItemToCenter(domWraps[nextIndex], 'smooth');
      });

      logicalWraps.forEach((wrap) => {
        wrap.addEventListener('click', () => {
          setGalleryItemState(wrap, false);
          scrollGalleryItemToCenter(wrap, 'smooth');
        });
      });

      const initiallyChecked = activeItem();
      setGalleryItemState(initiallyChecked, false);
      requestAnimationFrame(() => centerCarouselItem(initiallyChecked, 'auto'));
    }

    hasFlavorSelection() {
      return this.flavorQuantities.size > 0 && this.getFlavorBaseTotal() > 0;
    }

    getFlavorBaseTotal() {
      return [...this.flavorQuantities.values()].reduce((sum, qty) => sum + Math.max(0, Number(qty) || 0), 0);
    }

    getEffectiveQuantity() {
      return this.hasFlavorSelection() ? this.getFlavorBaseTotal() * this.getQuantity() : this.getQuantity();
    }

    getFlavorVariant(flavor) {
      if (!Number.isFinite(this.flavorIndex) || this.flavorIndex < 0) return null;
      return this.variants.find((variant) => (variant.options || []).every((value, index) => {
        const desired = index === this.flavorIndex ? flavor : this.options[index];
        return String(value) === String(desired);
      })) || null;
    }

    selectFlavor(flavor) {
      if (!flavor || !Number.isFinite(this.flavorIndex) || this.flavorIndex < 0) return;
      this.options[this.flavorIndex] = flavor;
      this.flavorWraps.forEach((wrap) => {
        const active = String(wrap.dataset.camoFlavor) === String(flavor);
        wrap.classList.toggle('is-camo-flavor-gallery-active', active);
        const input = wrap.querySelector('input[type="radio"]');
        if (input) input.checked = active;
      });
    }

    changeFlavorQuantity(flavor, delta) {
      if (!flavor) return;
      const current = Math.max(0, Number(this.flavorQuantities.get(flavor)) || 0);
      const next = Math.max(0, current + delta);
      if (next > 0) {
        this.flavorQuantities.set(flavor, next);
        this.lastTouchedFlavor = flavor;
        this.selectFlavor(flavor);
      } else {
        this.flavorQuantities.delete(flavor);
      }
      this.renderFlavorQuantities();
      this.update();
    }

    renderFlavorQuantities() {
      const multiplier = this.getQuantity();
      this.flavorWraps.forEach((wrap) => {
        const base = Math.max(0, Number(this.flavorQuantities.get(wrap.dataset.camoFlavor || '')) || 0);
        const actual = base * multiplier;
        const badge = wrap.querySelector('[data-camo-flavor-badge]');
        wrap.classList.toggle('has-camo-flavor-qty', actual > 0);
        if (badge) {
          badge.textContent = String(actual);
          badge.hidden = actual <= 0;
        }
      });
    }

    updateFlavorImages() {
      if (!this.flavorImages.length || !Number.isFinite(this.flavorIndex) || this.flavorIndex < 0) return;
      this.flavorWraps.forEach((wrap) => {
        const flavor = wrap.dataset.camoFlavor || '';
        const match = this.flavorImages.find((entry) => Array.isArray(entry.options) && entry.options.every((value, index) => {
          const desired = index === this.flavorIndex ? flavor : this.options[index];
          return !desired || String(value) === String(desired);
        }));
        if (!match?.image) return;
        const artwork = wrap.querySelector('.camo-flavor-gallery__artwork');
        if (!artwork) return;
        let image = artwork.querySelector('.camo-flavor-gallery__image');
        if (!image) {
          image = document.createElement('img');
          image.className = 'camo-flavor-gallery__image';
          image.loading = 'lazy';
          image.alt = '';
          artwork.prepend(image);
        }
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        if (image.getAttribute('src') !== match.image) image.setAttribute('src', match.image);
      });
    }

    applyFlavorMilestone(targetQuantity) {
      const target = Math.max(1, Number(targetQuantity) || 1);
      const multiplier = Math.max(1, this.getQuantity());
      if (!this.hasFlavorSelection()) {
        const flavor = this.options[this.flavorIndex] || this.flavorWraps[0]?.dataset.camoFlavor || '';
        if (flavor) this.flavorQuantities.set(flavor, 0);
      }
      let guard = 0;
      while (this.getFlavorBaseTotal() * multiplier < target && guard < 500) {
        const flavors = [...this.flavorQuantities.keys()].filter(Boolean);
        const candidates = flavors.length ? flavors : [this.options[this.flavorIndex] || this.flavorWraps[0]?.dataset.camoFlavor || ''];
        const min = Math.min(...candidates.map((flavor) => Math.max(0, Number(this.flavorQuantities.get(flavor)) || 0)));
        const chosen = candidates.find((flavor) => Math.max(0, Number(this.flavorQuantities.get(flavor)) || 0) === min) || candidates[0];
        if (!chosen) break;
        this.flavorQuantities.set(chosen, Math.max(0, Number(this.flavorQuantities.get(chosen)) || 0) + 1);
        this.lastTouchedFlavor = chosen;
        guard += 1;
      }
      this.renderFlavorQuantities();
      this.update();
    }

    buildFlavorCartItems() {
      if (!this.hasFlavorSelection()) return [];
      const multiplier = Math.max(1, this.getQuantity());
      const items = [];
      this.flavorQuantities.forEach((baseQty, flavor) => {
        const variant = this.getFlavorVariant(flavor);
        const quantity = Math.max(0, Number(baseQty) || 0) * multiplier;
        if (variant?.id && variant.available && quantity > 0) items.push({ id: Number(variant.id), quantity });
      });
      return items;
    }

    syncAcceleratedCheckoutItems() {
      if (!this.form || !this.variantInput || !this.qtyInput) return;

      this.form.querySelectorAll('[data-camo-accelerated-item]').forEach((input) => input.remove());
      this.qtyInput.setAttribute('name', 'quantity');

      const items = this.buildFlavorCartItems();
      if (!items.length) return;

      const [mainItem, ...additionalItems] = items;
      this.variantInput.value = String(mainItem.id);
      this.variantInput.setAttribute('value', String(mainItem.id));
      this.qtyInput.removeAttribute('name');

      const appendHiddenInput = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = String(value);
        input.dataset.camoAcceleratedItem = 'true';
        this.form.appendChild(input);
      };

      appendHiddenInput('quantity', mainItem.quantity);
      additionalItems.forEach((item, index) => {
        const itemIndex = index + 1;
        appendHiddenInput(`shopify-additional-items[${itemIndex}][id]`, item.id);
        appendHiddenInput(`shopify-additional-items[${itemIndex}][quantity]`, item.quantity);
      });
    }

    async addFlavorItems() {
      const items = this.buildFlavorCartItems();
      if (!items.length) return false;
      this.cartAdd?.setAttribute('xo-loading', 'true');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
        const resultText = await response.text();
        let result = {};
        try { result = resultText ? JSON.parse(resultText) : {}; } catch (error) { result = { raw: resultText }; }
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add selected flavors to cart.');
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((cartResponse) => cartResponse.ok ? cartResponse.json() : null)
          .catch(() => null);
        const detail = { items, response: result, cart };
        await refreshCartDrawer(detail);
        return true;
      } catch (error) {
        console.error(error);
        window.alert(error?.message || 'Unable to add selected flavors to cart.');
        return true;
      } finally {
        this.cartAdd?.removeAttribute('xo-loading');
      }
    }

    installFlavorIntegration() {
      if (this.card.dataset.hasFlavorVariants !== 'true' || !this.flavorWraps.length) return;
      this.form.camoApplyFlavorMilestone = (target) => this.applyFlavorMilestone(target);

      this.flavorWraps.forEach((wrap) => {
        wrap.addEventListener('click', (event) => {
          const flavor = wrap.dataset.camoFlavor || '';
          if (event.target.closest('[data-camo-flavor-minus]')) {
            event.preventDefault(); event.stopPropagation();
            this.changeFlavorQuantity(flavor, -1);
            return;
          }
          if (event.target.closest('[data-camo-flavor-plus]')) {
            event.preventDefault(); event.stopPropagation();
            this.changeFlavorQuantity(flavor, 1);
            return;
          }
          const now = Date.now();
          if (this.flavorClickStamp.flavor === flavor && now - this.flavorClickStamp.time < 160) return;
          this.flavorClickStamp = { flavor, time: now };
          this.selectFlavor(flavor);
          this.changeFlavorQuantity(flavor, 1);
        });
      });

      this.form?.addEventListener('submit', (event) => {
        if (!this.hasFlavorSelection()) return;
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation?.();
        this.addFlavorItems();
      }, true);

      this.addButton?.addEventListener('click', (event) => {
        if (!this.hasFlavorSelection()) return;
        event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation?.();
        this.addFlavorItems();
      }, true);

      this.renderFlavorQuantities();
      this.updateFlavorImages();
    }

    installQuickshopSummaryPlacement() {
      const summary = this.card.querySelector('.xo-product-card-v2__selection-summary--card');
      const hoverCard = this.card.querySelector('.xo-product-card-v2__hover-card');
      if (!summary || !hoverCard || summary.dataset.quickshopPlacementReady === 'true') return;

      summary.dataset.quickshopPlacementReady = 'true';
      const homeMarker = document.createComment('card-selection-summary-home');
      summary.parentNode.insertBefore(homeMarker, summary);

      const syncPlacement = () => {
        const isQuickshopActive = this.card.classList.contains('is-collection-quickshop-active');

        if (isQuickshopActive) {
          summary.classList.remove('xo-product-card-v2__selection-summary--card');
          summary.classList.add('xo-product-card-v2__selection-summary--quickshop');

          const savings = hoverCard.querySelector('.xo-product-card-v2__savings');
          if (savings) {
            hoverCard.insertBefore(summary, savings);
          } else {
            hoverCard.appendChild(summary);
          }
          return;
        }

        summary.classList.remove('xo-product-card-v2__selection-summary--quickshop');
        summary.classList.add('xo-product-card-v2__selection-summary--card');
        if (homeMarker.parentNode) {
          homeMarker.parentNode.insertBefore(summary, homeMarker.nextSibling);
        }
      };

      this.quickshopSummaryObserver = new MutationObserver(syncPlacement);
      this.quickshopSummaryObserver.observe(this.card, { attributes: true, attributeFilter: ['class'] });
      syncPlacement();
    }

    getInitialOptions() {
      const first = this.variants[0];
      const selected = this.variants.find((variant) => String(variant.id) === String(this.card.dataset.selectedVariantId)) || first;
      return selected?.options ? [...selected.options] : [];
    }

    applyActiveFilterSelection() {
      const active = getActiveCollectionOptionFilters(this.card);
      let changed = false;

      this.card.querySelectorAll('[data-option-name][data-option-index]').forEach((group) => {
        const optionName = handleize(group.dataset.optionName);
        const index = Number(group.dataset.optionIndex);
        if (!Number.isFinite(index)) return;

        let requiredValue = '';
        if (optionName === 'type') requiredValue = active.type;
        if (optionName === 'pack-type' || optionName === 'pack') requiredValue = active.packType;
        if (!requiredValue) return;

        const matchingButton = [...group.querySelectorAll('[data-card-option-value]')].find((button) => {
          return normalizeFilterValue(button.dataset.cardOptionHandle || button.dataset.cardOptionValue) === requiredValue;
        });
        if (!matchingButton) return;

        const nextValue = matchingButton.dataset.cardOptionValue;
        if (String(this.options[index]) !== String(nextValue)) {
          this.options[index] = nextValue;
          changed = true;
        }
      });

      return changed;
    }

    syncActiveFilterContext() {
      const changed = this.applyActiveFilterSelection();
      applyCollectionFilterVisibility(this.card);
      if (changed) this.update();
    }

    installCartAddOptionsBridge() {
      if (!this.cartAdd || this.cartAdd.dataset.camoSubmissionBridge === 'true') return;

      const nativeGetOptions = typeof this.cartAdd.getOptions === 'function'
        ? this.cartAdd.getOptions.bind(this.cartAdd)
        : null;

      this.cartAdd.getOptions = () => {
        const options = nativeGetOptions ? nativeGetOptions() : {};
        return {
          ...options,
          xoProductId: String(this.variantInput?.value || options.xoProductId || ''),
          xoProductQuantity: this.getQuantity()
        };
      };

      this.cartAdd.dataset.camoSubmissionBridge = 'true';
    }

    syncSubmissionState(variant = this.getVariant(), qty = this.getQuantity()) {
      if (!variant) return;

      const variantId = String(variant.id);
      const quantity = String(Math.max(1, Number(qty) || 1));

      if (this.variantInput) {
        const changed = String(this.variantInput.value) !== variantId;
        this.variantInput.value = variantId;
        this.variantInput.setAttribute('value', variantId);
        if (changed) this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (this.qtyInput) {
        this.qtyInput.value = quantity;
        this.qtyInput.setAttribute('value', quantity);
      }

      if (this.cartAdd) {
        this.cartAdd.setAttribute('xo-product-id', variantId);
        this.cartAdd.setAttribute('xo-product-quantity', quantity);
      }
    }

    bind() {
      this.card.querySelectorAll('[data-card-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
          const group = button.closest('[data-option-index]');
          const index = Number(group?.dataset.optionIndex);
          if (!Number.isFinite(index)) return;
          this.options[index] = button.dataset.cardOptionValue;
          this.updateOptionButtons();
          this.updateFlavorImages();
          this.update();
        });
      });

      this.card.querySelector('[data-card-qty-minus]')?.addEventListener('click', () => this.setQuantity(this.getQuantity() - 1));
      this.card.querySelector('[data-card-qty-plus]')?.addEventListener('click', () => this.setQuantity(this.getQuantity() + 1));
      this.qtyInput?.addEventListener('input', () => { this.renderFlavorQuantities(); this.update(); });
      this.qtyInput?.addEventListener('change', () => this.setQuantity(this.getQuantity()));

      const syncBeforePurchase = () => {
        this.syncSubmissionState();
        this.syncAcceleratedCheckoutItems();
      };
      this.form?.addEventListener('submit', syncBeforePurchase, true);
      this.addButton?.addEventListener('pointerdown', syncBeforePurchase, true);
      this.addButton?.addEventListener('click', syncBeforePurchase, true);
      this.dynamicCheckout?.addEventListener('pointerdown', syncBeforePurchase, true);
      this.dynamicCheckout?.addEventListener('click', syncBeforePurchase, true);

      this.milestonesWrap?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-card-milestone-qty]');
        if (!button) return;
        const target = Number(button.dataset.cardMilestoneQty);
        if (typeof this.form?.camoApplyFlavorMilestone === 'function') {
          this.form.camoApplyFlavorMilestone(target);
        } else {
          this.setQuantity(target);
        }
      });
    }

    getQuantity() {
      const qty = parseInt(this.qtyInput?.value || '1', 10);
      return Number.isFinite(qty) && qty > 0 ? qty : 1;
    }

    setQuantity(qty) {
      const next = Math.max(1, parseInt(qty || '1', 10));
      if (this.qtyInput) {
        this.qtyInput.value = String(next);
        this.qtyInput.setAttribute('value', String(next));
        this.qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.update();
    }

    getVariant() {
      return this.variants.find((variant) => {
        return (variant.options || []).every((value, index) => String(value) === String(this.options[index]));
      }) || this.variants.find((variant) => String(variant.id) === String(this.variantInput?.value)) || this.variants[0];
    }

    getVariantUrl(variant) {
      const base = this.card.dataset.productUrl || window.location.pathname;
      const url = new URL(base, window.location.origin);
      const activeFilters = getActiveCollectionOptionFilters(this.card);

      if (variant?.id) url.searchParams.set('variant', String(variant.id));
      if (activeFilters.type) url.searchParams.set('filter_type', activeFilters.type === 'wraps' ? 'Wraps' : 'Cones');
      if (activeFilters.packType) url.searchParams.set('filter_pack_type', activeFilters.packType === 'boxes' ? 'Boxes' : 'Pouches');

      return `${url.pathname}${url.search}${url.hash}`;
    }

    getVariantImageSrc(variant) {
      const image = variant?.featured_image || variant?.featured_media?.preview_image || null;
      if (!image) return '';
      return image.src || image.url || image.preview_image?.src || '';
    }

    updateMediaAndLinks(variant) {
      const url = this.getVariantUrl(variant);
      this.card.querySelectorAll('.xo-product-card-v2__image-link, .xo-product-card-v2__learn-more').forEach((link) => {
        link.setAttribute('href', url);
      });

      const src = this.getVariantImageSrc(variant);
      if (!src) return;
      const image = this.card.querySelector('.xo-product-card-v2__image-link img');
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
    }

    updateOptionButtons() {
      this.card.querySelectorAll('[data-option-index]').forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-card-option-value]').forEach((button) => {
          button.classList.toggle('is-selected', String(button.dataset.cardOptionValue) === String(this.options[index]));
        });
      });
      this.updatePackTypeOptionDetails();
    }

    updatePackTypeOptionDetails() {
      const typeGroup = this.card.querySelector('[data-option-name="Type"]');
      const packGroup = this.card.querySelector('[data-option-name="Pack Type"], [data-option-name="Pack"]');
      const typeIndex = Number(typeGroup?.dataset.optionIndex);
      if (!packGroup || !Number.isFinite(typeIndex)) return;

      const isCones = handleize(this.options[typeIndex]) === 'cones';

      packGroup.querySelectorAll('[data-card-option-value]').forEach((button) => {
        const packType = normalizeFilterValue(button.dataset.cardOptionHandle || button.dataset.cardOptionValue);
        const detail = button.querySelector('.xo-product-card-v2__option-detail');
        if (!detail) return;

        if (packType === 'boxes') detail.textContent = isCones ? '12 pouches each' : '25 pouches each';
        if (packType === 'pouches') detail.textContent = isCones ? '4 cones each' : '5 wraps each';
      });
    }

    getGroup(variantId) {
      const direct = this.groups.find((group) => {
        const ids = group.variant_ids || group.variantIds || [];
        return ids.map(String).includes(String(variantId));
      });
      if (direct) return direct;

      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      const typeGroup = this.card.querySelector('[data-option-name="Type"]');
      const packGroup = this.card.querySelector('[data-option-name="Pack Type"], [data-option-name="Pack"]');
      const typeIndex = Number(typeGroup?.dataset.optionIndex);
      const packIndex = Number(packGroup?.dataset.optionIndex);
      const type = Number.isFinite(typeIndex) ? handleize(variant?.options?.[typeIndex]) : '';
      const pack = Number.isFinite(packIndex) ? handleize(variant?.options?.[packIndex]) : '';

      const contextual = this.groups.find((group) => {
        const groupType = handleize(group.product_type ?? group.productType ?? group.type);
        const groupPack = handleize(group.pack_type ?? group.packType ?? group.pack);
        return (!groupType || groupType === type) && (!groupPack || groupPack === pack);
      });

      return contextual || this.groups.find((group) => !group.variant_ids && !group.variantIds) || null;
    }

    getActiveBreakpoint(group, qty) {
      const all = sortedBreakpoints(group);
      let active = { quantity: 1, discount_percentage: 0 };
      all.forEach((bp) => { if (bp.quantity <= qty) active = bp; });
      return active;
    }

    update() {
      const variant = this.getVariant();
      if (!variant) return;

      const qty = this.getEffectiveQuantity();
      const group = this.getGroup(variant.id);
      const activeBp = this.getActiveBreakpoint(group, qty);
      const currency = group?.currency || this.pricing?.currency || 'USD';
      const pouchCount = Math.max(1, Number(group?.pouch_count_per_unit) || 1);
      const base = (Number(variant.price) || 0) / 100;
      const discount = Math.max(0, Number(activeBp?.discount_percentage) || 0);
      const total = base * qty * (1 - discount / 100);
      const perPouch = total / Math.max(1, qty * pouchCount);

      this.options = variant.options ? [...variant.options] : this.options;
      this.syncSubmissionState(variant, this.getQuantity());
      this.card.dataset.selectedVariantId = variant.id;
      this.updateOptionButtons();
      this.updateMediaAndLinks(variant);
      this.updateFlavorImages();

      if (this.totalEl) this.totalEl.textContent = money(total, currency);
      if (this.perPouchEl) this.perPouchEl.textContent = group ? `${money(perPouch, currency)} per pouch` : '';

      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        this.addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      this.renderSelectionSummary(group, variant, qty);
      this.renderMilestones(group, variant, qty, currency);
    }

    renderSelectionSummary(group, variant, qty) {
      if (!this.selectionSummaries.length || !variant) return;

      const optionNames = Array.isArray(variant.options) ? variant.options : [];
      const typeGroup = this.card.querySelector('[data-option-name="Type"]');
      const packGroup = this.card.querySelector('[data-option-name="Pack Type"], [data-option-name="Pack"]');
      const typeIndex = Number(typeGroup?.dataset.optionIndex);
      const packIndex = Number(packGroup?.dataset.optionIndex);
      const type = Number.isFinite(typeIndex) ? String(optionNames[typeIndex] || '') : '';
      const packType = Number.isFinite(packIndex) ? String(optionNames[packIndex] || '') : '';

      if (!type || !packType || !qty) {
        this.selectionSummaries.forEach((summary) => { summary.hidden = true; });
        return;
      }

      const normalizedType = type.toLowerCase();
      const normalizedPack = packType.toLowerCase();
      const isCones = normalizedType.includes('cone');
      const isBoxes = normalizedPack.includes('box');
      const pouchCountPerUnit = Math.max(1, Number(group?.pouch_count_per_unit) || (isBoxes ? (isCones ? 12 : 25) : 1));
      const piecesPerPouch = Math.max(1, Number(
        group?.pieces_per_pouch ??
        group?.wraps_per_pouch ??
        group?.cones_per_pouch ??
        group?.units_per_pouch
      ) || (isCones ? 4 : 5));
      const totalPouches = qty * pouchCountPerUnit;
      const totalPieces = totalPouches * piecesPerPouch;
      const items = [
        { value: totalPieces, label: totalPieces === 1 ? (isCones ? 'Cone' : 'Wrap') : (isCones ? 'Cones' : 'Wraps') }
      ];
      if (isBoxes) items.push({ value: qty, label: qty === 1 ? 'Box' : 'Boxes' });
      items.push({ value: totalPouches, label: totalPouches === 1 ? 'Pouch' : 'Pouches' });

      this.selectionSummaries.forEach((summary) => {
        const container = summary.querySelector('[data-card-selection-summary-items]');
        if (!container) return;
        container.style.setProperty('--card-selection-summary-columns', String(items.length));
        container.innerHTML = items.map((item) => `
          <div class="xo-product-card-v2__selection-summary-item">
            <span class="xo-product-card-v2__selection-summary-value">${item.value}</span>
            <span class="xo-product-card-v2__selection-summary-label">${item.label}</span>
          </div>
        `).join('');
        summary.hidden = false;
      });
    }

    quantityLabel(quantity, packType) {
      const clean = String(packType || 'units').toLowerCase();
      const singular = ({ pouches: 'pouch', pouch: 'pouch', boxes: 'box', box: 'box', units: 'unit', unit: 'unit' }[clean]) || clean.replace(/s$/, '');
      return quantity === 1 ? singular : `${singular}s`;
    }

    renderMilestones(group, variant, qty, currency) {
      if (!this.milestones || !this.milestonesWrap || !group) return;
      const breakpoints = sortedBreakpoints(group);
      if (!breakpoints.length) {
        this.milestones.hidden = true;
        return;
      }

      this.milestones.hidden = false;
      const key = `${variant.id}:${breakpoints.map((bp) => `${bp.quantity}-${bp.discount_percentage}`).join('|')}`;
      const pouchCount = Math.max(1, Number(group.pouch_count_per_unit) || 1);
      const base = (Number(variant.price) || 0) / 100;
      const activeIndex = breakpoints.reduce((acc, bp, index) => qty >= bp.quantity ? index : acc, -1);
      this.milestonesWrap.style.setProperty('--card-milestone-count', String(Math.max(1, breakpoints.length)));

      if (key !== this.lastMilestoneKey) {
        this.milestonesWrap.innerHTML = breakpoints.map((bp) => `
          <button class="xo-product-card-v2__milestone" type="button" data-card-milestone-qty="${bp.quantity}">
            <span class="xo-product-card-v2__milestone-number"></span>
            <span class="xo-product-card-v2__milestone-label"></span>
            <span class="xo-product-card-v2__milestone-save"></span>
            <span class="xo-product-card-v2__milestone-price"></span>
          </button>
        `).join('');
        this.lastMilestoneKey = key;
      }

      this.milestonesWrap.querySelectorAll('[data-card-milestone-qty]').forEach((node, index) => {
        const bp = breakpoints[index];
        const unitPrice = base * (1 - bp.discount_percentage / 100) / pouchCount;
        node.classList.toggle('is-active', index === activeIndex);
        node.classList.toggle('is-passed', qty > bp.quantity);
        node.querySelector('.xo-product-card-v2__milestone-number').textContent = bp.quantity;
        node.querySelector('.xo-product-card-v2__milestone-label').textContent = this.quantityLabel(bp.quantity, group.pack_type);
        node.querySelector('.xo-product-card-v2__milestone-save').textContent = `Save ${bp.discount_percentage}%`;
        node.querySelector('.xo-product-card-v2__milestone-price').textContent = `${money(unitPrice, currency)} / Pouch`;
      });
    }
  }

  const init = (root = document) => {
    const cards = [];
    if (root instanceof Element && root.matches(CARD_SELECTOR)) cards.push(root);
    if (root?.querySelectorAll) cards.push(...root.querySelectorAll(CARD_SELECTOR));

    cards.forEach((card) => {
      applyCollectionFilterVisibility(card);
      if (card.dataset.camoCardV2Initialized) {
        card.camoProductCardV2Instance?.syncActiveFilterContext();
        return;
      }
      card.dataset.camoCardV2Initialized = 'true';
      const instance = new CamoProductCardV2(card);
      card.camoProductCardV2Instance = instance;
    });
  };

  let initFrame = null;
  const scheduleInit = (root = document) => {
    if (initFrame) window.cancelAnimationFrame(initFrame);
    initFrame = window.requestAnimationFrame(() => {
      initFrame = null;
      init(root);
    });
  };

  const watchFilteredCards = () => {
    if (window.camoProductCardV2Observer) return;
    window.camoProductCardV2Observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches?.(CARD_SELECTOR) || node.querySelector?.(CARD_SELECTOR)) {
            scheduleInit(document);
            return;
          }
        }
      }
    });
    window.camoProductCardV2Observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); watchFilteredCards(); });
  } else {
    init();
    watchFilteredCards();
  }

  document.addEventListener('shopify:section:load', (event) => scheduleInit(event.target || document));
  document.addEventListener('shopify:section:select', (event) => scheduleInit(event.target || document));
  document.addEventListener('xo:filters:update', () => scheduleInit(document));
  document.addEventListener('xo:filters:updated', () => scheduleInit(document));
  document.addEventListener('change', (event) => {
    if (event.target?.closest?.('xo-filters, xo-filters-field, xo-filters-refine')) {
      window.setTimeout(() => scheduleInit(document), 0);
      window.setTimeout(() => scheduleInit(document), 150);
    }
  });
  window.addEventListener('popstate', () => scheduleInit(document));

  const nativePushState = history.pushState.bind(history);
  const nativeReplaceState = history.replaceState.bind(history);
  history.pushState = (...args) => {
    const result = nativePushState(...args);
    scheduleInit(document);
    return result;
  };
  history.replaceState = (...args) => {
    const result = nativeReplaceState(...args);
    scheduleInit(document);
    return result;
  };
})();
